import React, { FC, useEffect } from 'react';

import styles from './PurchasedDeviceSelector.module.css';
import { PromoDeviceProps, PurchasedPhone } from '../../state/types';
import { useState } from '../../state/store';
import cls from 'classnames';

interface Props {
  purchasedPhone: PurchasedPhone | null;
  handlePhoneSelect: (purchasedPhone: PromoDeviceProps) => (event: any) => void;
}

const PurchasedDeviceSelector: FC<Props> = ({ purchasedPhone, handlePhoneSelect }) => {
  const { promoDevices, promoDeviceCount, dispatch } = useState('promoDevices', 'promoDeviceCount');

  const PromoDeviceImages = promoDevices.map((promoPhone) => (
    <div
      className={cls('col-12 pb-md-0 pb-3', styles.dmBlock, `col-md-${Math.floor(12 / promoDeviceCount)}`)}
      key={promoPhone.alias}
    >
      <button
        className={cls(
          styles.phoneButton,
          { [styles.selected]: purchasedPhone === promoPhone.alias },
          { [styles.blurred]: purchasedPhone && purchasedPhone !== promoPhone.alias }
        )}
        onClick={handlePhoneSelect(promoPhone)}
      >
        <h3 className="text-center pt-3">{promoPhone.full_name}</h3>
        <img src={promoPhone.image_path} alt={promoPhone.full_name} className="d-inline-block" />
        <p className={cls('lead pt-3', { [styles.hideClick]: purchasedPhone != null })}>Click here</p>
      </button>
    </div>
  ));

  return (
    <div className={`${styles.PurchasedDeviceSelector} pt-6`}>
      <div className="row pt-6">{PromoDeviceImages}</div>
    </div>
  );
};

export default PurchasedDeviceSelector;
